/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import { classNames } from "../../helpers/classNames";

/**
 * ItemMenu component — a three-dot dropdown menu for contextual item actions.
 *
 * Renders a vertical dots trigger button that opens a Headless UI dropdown
 * listing all provided action options, each with an icon and label.
 *
 * @component
 * @param {Object} props
 * @param {Array<{title: string, icon: React.ElementType, action: function}>} [props.options]
 *   List of menu items. Each item needs a display `title`, an `icon` component, and an `action` callback.
 * @returns {JSX.Element} A dropdown menu button.
 */
export default function ItemMenu({ options = [{title: 'No Show', icon: DotsVerticalIcon, action: () => {}}] }) {

  return (
    <Menu as="div" className="relative inline-block text-left ">
      <div>
        <Menu.Button className="z-20 rounded-full flex items-center text-gray-500 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-gray-500">
          <span className="sr-only">Open options</span>
          <DotsVerticalIcon className="h-5 w-5" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="z-30 origin-top-right absolute right-2 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {options.map((option, index) => (
              <Menu.Item key={index}>
                {({ active }) => (
                  <button
                    onClick={() => {
                      option.action();
                    }}
                    className={classNames(
                      active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                      "flex space-x-2 items-center px-3 py-2 text-sm w-full "
                    )}
                  >
                    {" "}
                    <option.icon className={classNames("h-5 bg-transparent")} />
                   <p className="text-left">{option.title}</p> 
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
